import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { LOAN_PRODUCTS } from "../lib/data";

export const LoanPortfolio = ({ prefix = "product" }) => (
  <div className="portfolio-grid" data-testid={`${prefix}-grid`}>
    {LOAN_PRODUCTS.map((product) => <LoanCard key={product.id} product={product} prefix={prefix} />)}
  </div>
);

const LoanCard = ({ product, prefix }) => {
  const [selected, setSelected] = useState(false);
  const Icon = Icons[product.icon] || Icons.Building2;
  const testId = `${prefix}-${product.id}`;
  const consultation = `/contact?loan=${encodeURIComponent(product.name)}#lead`;
  return (
    <article className={`portfolio-card ${selected ? "is-selected" : ""}`} style={{ "--card-start": product.colors[0], "--card-end": product.colors[1] }} data-testid={testId}>
      <button type="button" className="portfolio-select" onClick={() => setSelected(!selected)} aria-pressed={selected} aria-label={`Highlight ${product.name}`} data-testid={`${testId}-highlight`} />
      <div className="portfolio-copy">
        <span className="portfolio-eyebrow">CREW CONNECT FININVESTO</span>
        <h3 className="font-heading font-bold" data-testid={`${testId}-title`}>{product.name}</h3>
        <p data-testid={`${testId}-caption`}>{product.desc}</p>
      </div>
      <Icon className="portfolio-illustration" size={72} strokeWidth={1.15} aria-hidden="true" />
      <div className="portfolio-actions">
        <Link to={consultation} className="portfolio-apply" data-testid={`${testId}-apply`}>Apply Now <Icons.ArrowUpRight size={15} /></Link>
        <Link to={consultation} className="portfolio-more" data-testid={`${testId}-more`}>Know More <Icons.ArrowRight size={14} /></Link>
      </div>
    </article>
  );
};